import React, { useEffect, useState } from 'react'
import { Button, Modal, TableAdv } from '../../../../../components';
import { mapTableRows } from '../../../../../utils';
import { usePagination } from '../../../../../hooks';
import { fetchNoActivityJobs } from '../../../../../redux/slices/bdmjobs/bdmjobsApi';
import { useDispatch } from 'react-redux';
import { setExpiringJobsDisplayedOn } from '../../../../../redux/slices/bdmjobs/bdmjobsSlice';

const ExpiringJobs = ({days, onClose}) => {
    const [expiringJobs, setexpiringJobs] = useState();
    const [totalCount, setTotalCount] = useState();
    const [isCloseModel, setIsCloseModel] = useState(false);
    const dispatch = useDispatch();

    const { page, limit, setPage, handleLimitChange } = usePagination( 10, (newPage, newLimit) => { } );
    
    const columns = [
        { key: "jobTitle", label: "Job Title" },
        { key: "jobCode", label: "Job Code", },
        { key: "companyName", label: "Company Name" },
    ];

    const rows = Array.from({ length: expiringJobs?.length }, (_, i) => ({
        jobTitle: expiringJobs?.[i]?.job?.title,
        jobCode: expiringJobs?.[i]?.jobInfo?.jobCode,
        companyName: expiringJobs?.[i]?.company?.name
    }));    

    const mappedRows = mapTableRows(rows, columns);

    const fetchExpiringJobs = async () => {
        const params = {
            coll: "JobPosting",
            fil: JSON.stringify({jobInactivityLimitDays: {type: "JOBS_NO_ACTIVITY", value: days}}),
            useAggregate: true,
            ret: "job.uiid job.title job.description jobInfo.jobCode currentStatus addedOn company.uiid company.name",
            lim: limit,
            pg: page,
        }
        const response = await fetchNoActivityJobs(params);

        if (response?.success) {
            setexpiringJobs(response.data?.data?.[0]?.data);
            setTotalCount(response.data?.data?.[0]?.totalCount);
        } else {
            showToast("Unable to fetch expiring jobs", "error");
            onClose();
        }
    };

    useEffect(() => {
        fetchExpiringJobs();
    }, [page, limit])

    const handleClose = () => {
        dispatch(setExpiringJobsDisplayedOn(new Date().toISOString().split("T")[0]));
        setIsCloseModel(false);
        onClose();
    };

    return (
        <div>
            <TableAdv
                columns={columns}
                rows={mappedRows}
                showSlNo={true}
                serverPagination={true}
                totalCount={totalCount}
                page={page}
                limit={limit}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                toolbarRight={{
                    search: false,
                    filter: false
                }}
            />
            <div className='flex justify-center mt-5'>
                <Button title="Close" onClick={() => setIsCloseModel(true)} />
            </div>

            <Modal
                isOpen={isCloseModel}
                showCloseButton={false}
                title={"Jobs Closing Today"}
                titleColor={"primary"}
            >
                <div className='text-center'>
                    <p className='font-medium text-lg'>These Jobs will be closing today.</p>
                    <div className='flex justify-center gap-2 mt-5'>
                        <Button
                            title={"Cancel"}
                            variant='text'
                            color='gray'
                            onClick={() => setIsCloseModel(false)}
                        />
                        <Button
                            title={"Close"}
                            onClick={handleClose}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ExpiringJobs